import React, {useState, useEffect, useRef} from 'react'
import axios from 'axios';
import Skeleton from "@mui/material/Skeleton";
import moment from "moment";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { Table, TableCell, TableRow } from "@mui/material";
import TableComponent from '../../../../Atoms/TableComponent';
import { Check, Clear, Event } from "@material-ui/icons";
import { useParams } from "react-router-dom";
import { url } from '../../../../../Config';
import Box from "@mui/material/Box";
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import IconButton from "@mui/material/IconButton";
import Swal from "sweetalert2";
import ApprovalIcon from '@mui/icons-material/Approval';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Tooltip from '@mui/material/Tooltip';


export default function Vis_approvals(props) {

    const [data, setdata] = useState([]);
    const [bool, setbool] = useState(true);
    const [alertopen, setalertOpen] = useState(false);
    const [alertType, setalertType] = useState();
    const [AlertMessage, setalertmessage] = useState();
    const [alertopen2, setalertOpen2] = useState(false);
    const [alertType2, setalertType2] = useState();
    const [AlertMessage2, setalertmessage2] = useState();
 
    useEffect(()=>{
            const func = async ()=>{
                
                const res = await axios.get(`${url}/api/get_vis_approvals`);
                const resp = res.data;
                setdata(resp);
            }

            func();
        },[bool])

  const gridRef = useRef();
  const responsiveColumns = () => {
    if (props.screenWidth < 770) {
      return null;
    } else {
      return 210;
    }
  };

  const responsiveColumnPin = () => {
    if (props.screenWidth < 770) {
      return null;
    } else {
      return "left";
    }
  };

  const detailShow = () => {
    if (props.screenWidth < 770) {
      return false;
    } else {
      return true;
    }
  };

  const sectorHide = () => {
    if (props.screenWidth > 500) {
      return false;
    } else {
      return true;
    }
  };

    const cellrandered = (params) => {
    if (params.value === "nullData") {
      return <Skeleton />;
    } else {
      return params.value;
    }
  };

  function fullDate(params) {
        if (params.value === "nullData") return <Skeleton />;
        if (params.value == null) {
          return "-";
        } else if (params.value == "") {
          return "-";
        }
        else if(params.value == "Request for Opinion"){
          return "Request for Opinion";
        }
        
        else {
          const date = new Date(params.value);
          const yyyy = date.getFullYear();
          const yy = yyyy.toString();
          const y = yy.slice(2, 4);
          let mm = date.toLocaleString("default", { month: "short" });
          let dd = date.getDate();
          if (dd < 10) dd = "0" + dd;
          return dd + "-" + mm + "-" + y;
        }
      }

  const requestApproveUpdate = async (main_id, op_id) =>{

    Swal.fire({ title: 'Do you want to Approve Update Request?', 
          showDenyButton: false, showCancelButton: true, confirmButtonText: 'Approve'})
          .then(async(result) => {
            if (result.isConfirmed) {
                setalertOpen(false);
                const res = await axios.post(`${url}/api/approve_update_opinion`, {
                'main_id': main_id,
                'opinion_id': op_id,
            });

            const resp = res.data;
            if(resp.status == true){
                setbool(!bool);
                setalertType("success");
                setalertOpen(true);
                setalertmessage(resp.message);
            }
            else{
                setbool(!bool);
                setalertType("error");
                setalertOpen(true);
                setalertmessage(resp.message);
            }

            }
            })
    
    
  }

  const requestApproveDelete = async (main_id, op_id) =>{

    Swal.fire({ title: 'Do you want to delete this Opinion?', 
          showDenyButton: false, showCancelButton: true, confirmButtonText: 'Approve'})
          .then(async(result) => {
            if (result.isConfirmed) {
                setalertOpen(false);
                const res = await axios.post(`${url}/api/approve_delete_jcr_client`, {
                'main_id': main_id,
                'opinion_id': op_id,
            });

            const resp = res.data;
            if(resp.status == true){
                setbool(!bool);
                setalertType("success");
                setalertOpen(true);
                setalertmessage(resp.message);
            }
            else{
                setbool(!bool);
                setalertType("error");
                setalertOpen(true);
                setalertmessage(resp.message);
            }

            }
            })
    
    
  }

  const requestApproveUpdateRating = async (main_id, r_id) =>{

    Swal.fire({ title: 'Do you want to Approve Update Request?', 
          showDenyButton: false, showCancelButton: true, confirmButtonText: 'Approve'})
          .then(async(result) => {
            if (result.isConfirmed) {
                setalertOpen(false);
                const res = await axios.post(`${url}/api/approve_update_rating`, {
                'main_id': main_id,
                'record_id': r_id,
            });

            const resp = res.data;
            if(resp.status == true){
                setbool(!bool);
                setalertType("success");
                setalertOpen(true);
                setalertmessage(resp.message);
            }
            else{
                setbool(!bool);
                setalertType("error");
                setalertOpen(true);
                setalertmessage(resp.message);
            }

            }
            })
    
    
  }

  const requestApproveDeleteRating = async (main_id, r_id) =>{

    Swal.fire({ title: 'Do you want to delete this Rating?', 
          showDenyButton: false, showCancelButton: true, confirmButtonText: 'Approve'})
          .then(async(result) => {
            if (result.isConfirmed) {
                setalertOpen(false);
                const res = await axios.post(`${url}/api/approve_delete_jcr_rating`, {
                'main_id': main_id,
                'record_id': r_id,
            });

            const resp = res.data;
            if(resp.status == true){
                setbool(!bool);
                setalertType("success");
                setalertOpen(true);
                setalertmessage(resp.message);
            }
            else{
                setbool(!bool);
                setalertType("error");
                setalertOpen(true);
                setalertmessage(resp.message);
            }

            }
            })
    
    
  }

    const columnDefs = [
    {
      headerName: "",
      field: "sNo",
      maxWidth: 30,
      filter: true,
      menuTabs: false,
      pinned: responsiveColumnPin(),
      hide: detailShow(),
      cellRenderer: "agGroupCellRenderer",
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
    },
    {
      headerName: "#",
      maxWidth: 50,
      field: "sNo",
      // minWidth: 66,
      sortable: true,
      filter: true,
      // filter: "agSetColumnFilter",
      headerComponentParams: {
        template:
          '<div class="ag-cell-label-container" role="presentation">' +
          '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
          '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
          '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
          '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
          '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
          '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
          '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
          '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
          "  </div>" +
          "</div>",
      },
      suppressFiltersToolPanel: true,
      menuTabs: false,
      cellRenderer: cellrandered,
      pinned: responsiveColumnPin(),
    },

    {
      headerName: "Opinion",
      minWidth: responsiveColumns(),
      field: "name",
      minWidth: 430,
      sortable: true,
      filter: "agSetColumnFilter",
      excelMode: "windows",
      filterParams: {
        caseSensitive: false,
      },
      cellRenderer: function (params) {
        if (params.value === "nullData") return <Skeleton />;
        else{
          if(params.data != null){
            return (
              <a
                href={`/vis-history/${params.data.opinion_id}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary"
              >
                {params.value}
              </a>
            );
        }
        }
      },
      // cellRenderer: cellrandered,
      tooltipField: "name",
      pinned: responsiveColumnPin(),
    },

    {
            headerName: "Dissemination Date",
            field: "jcr_dissemination_date",
            minWidth: 115,
            // hide: true,
            sortable: true,
            filter: "agDateColumnFilter",
            excelMode: "windows",
            cellRenderer: fullDate,
            debounceMs: "DateFilter",
            filterParams: {
              filterOptions: ["equals", "lessThan", "greaterThan", "inRange"],
              inRangeInclusive: true,
              comparator: function (filterLocalDateAtMidnight, cellValue) {
                var dateAsString = moment(cellValue).format("DD/MM/YYYY");
                var dateParts = dateAsString.split("/");
                var cellDate = new Date(
                  Number(dateParts[2]),
                  Number(dateParts[1]) - 1,
                  Number(dateParts[0])
                );
      
                if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                  return 0;
                }
      
                if (cellDate < filterLocalDateAtMidnight) {
                  return -1;
                }
      
                if (cellDate > filterLocalDateAtMidnight) {
                  return 1;
                }
              },
              buttons: ["clear", "reset", "apply"],
              headerComponentParams: {
                template:
                  '<div class="ag-cell-label-container" role="presentation">' +
                  '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                  '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
                  '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
                  '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
                  '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
                  '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
                  '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
                  '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                  "  </div>" +
                  "</div>",
              },
            },
    },

    {
      headerName: "Request",
      field: "request",
      minWidth: 130,
      hide: sectorHide(),
      sortable: true,
      excelMode: "windows",
      tooltipField: "Industry",
      cellRenderer: cellrandered
    },

    {
      headerName: "Action",
      field: "id",
      minWidth: 130,
      hide: sectorHide(),
      sortable: true,
      excelMode: "windows",
      tooltipField: "Industry",
      cellRenderer: (params)=>{

        if(params.data.request_for == "Opinion")
          {
              if(params.data.request == "Update"){
                return(
                    <>
                    <Tooltip title="Approve Update"><button className="btn btn-info" onClick={()=>{requestApproveUpdate(params.value, params.data.opinion_id)}}><ApprovalIcon/></button></Tooltip>
                    <Tooltip title="View"><button className='ms-1 btn btn-secondary' onClick={()=>{window.open(`/view-vis-op-changes/${params.data.opinion_id}`, '_blank')}}><VisibilityIcon /></button></Tooltip>
                    </>
                )
                  }
              else if (params.data.request == "Delete"){
                      return(
                          <Tooltip title="Approve Deletion"><button className="btn btn-info" onClick={()=>{requestApproveDelete(params.value, params.data.opinion_id)}}><ApprovalIcon/></button></Tooltip>
                      )
                }
          }

        else if(params.data.request_for == "Rating")
          {
            if(params.data.request == "Update"){
                return(
                    <>
                    <Tooltip title="Approve Update"><button className="btn btn-info" onClick={()=>{requestApproveUpdateRating(params.value, params.data.record_id)}}><ApprovalIcon/></button></Tooltip>
                    <Tooltip title="View"><button className="btn btn-secondary ms-1" onClick={()=>{window.open(`/view-ratings-jcr-changes/${params.data.record_id}`, "_blank")}}><VisibilityIcon /></button></Tooltip>
                    </>
                )
            }
            else if (params.data.request == "Delete"){
                    return(
                         <Tooltip title="Approve Deletion"><button className="btn btn-info" onClick={()=>{requestApproveDeleteRating(params.value, params.data.record_id)}}><ApprovalIcon/></button></Tooltip>
                    )
                }
          }
         
      },
    },

    ];

    // const columnDefs2 = [
    // {
    //   headerName: "",
    //   field: "sNo",
    //   maxWidth: 30,
    //   filter: true,
    //   menuTabs: false,
    //   pinned: responsiveColumnPin(),
    //   hide: detailShow(),
    //   cellRenderer: "agGroupCellRenderer",
    //   suppressColumnsToolPanel: true,
    //   suppressFiltersToolPanel: true,
    // },
    // {
    //   headerName: "#",
    //   maxWidth: 50,
    //   field: "sNo",
    //   // minWidth: 66,
    //   sortable: true,
    //   filter: true,
    //   // filter: "agSetColumnFilter",
    //   headerComponentParams: {
    //     template:
    //       '<div class="ag-cell-label-container" role="presentation">' +
    //       '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
    //       '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
    //       '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
    //       '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
    //       '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
    //       '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
    //       '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
    //       '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
    //       "  </div>" +
    //       "</div>",
    //   },
    //   suppressFiltersToolPanel: true,
    //   menuTabs: false,
    //   cellRenderer: cellrandered,
    //   pinned: responsiveColumnPin(),
    // },

    // {
    //   headerName: "Opinion",
    //   minWidth: responsiveColumns(),
    //   field: "name",
    //   minWidth: 430,
    //   sortable: true,
    //   filter: "agSetColumnFilter",
    //   excelMode: "windows",
    //   filterParams: {
    //     caseSensitive: false,
    //   },
    //   cellRenderer: cellrandered,
    //   tooltipField: "name",
    //   pinned: responsiveColumnPin(),
    // },

    // {
    //         headerName: "Dissemination Date",
    //         field: "jcr_dissemination_date",
    //         minWidth: 115,
    //         // hide: true,
    //         sortable: true,
    //         filter: "agDateColumnFilter",
    //         excelMode: "windows",
    //         cellRenderer: fullDate,
    //         debounceMs: "DateFilter",
    //         filterParams: {
    //           filterOptions: ["equals", "lessThan", "greaterThan", "inRange"],
    //           inRangeInclusive: true,
    //           comparator: function (filterLocalDateAtMidnight, cellValue) {
    //             var dateAsString = moment(cellValue).format("DD/MM/YYYY");
    //             var dateParts = dateAsString.split("/");
    //             var cellDate = new Date(
    //               Number(dateParts[2]),
    //               Number(dateParts[1]) - 1,
    //               Number(dateParts[0])
    //             );
      
    //             if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
    //               return 0;
    //             }
      
    //             if (cellDate < filterLocalDateAtMidnight) {
    //               return -1;
    //             }
      
    //             if (cellDate > filterLocalDateAtMidnight) {
    //               return 1;
    //             }
    //           },
    //           buttons: ["clear", "reset", "apply"],
    //           headerComponentParams: {
    //             template:
    //               '<div class="ag-cell-label-container" role="presentation">' +
    //               '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
    //               '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
    //               '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
    //               '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
    //               '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
    //               '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
    //               '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
    //               '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
    //               "  </div>" +
    //               "</div>",
    //           },
    //         },
    // },

    // {
    //   headerName: "Request",
    //   field: "request",
    //   minWidth: 130,
    //   hide: sectorHide(),
    //   sortable: true,
    //   excelMode: "windows",
    //   tooltipField: "Industry",
    //   cellRenderer: cellrandered
    // },

    // {
    //   headerName: "Action",
    //   field: "id",
    //   minWidth: 130,
    //   hide: sectorHide(),
    //   sortable: true,
    //   excelMode: "windows",
    //   tooltipField: "Industry",
    //   cellRenderer: (params)=>{
    //      if(params.data.request == "Update"){
    //             return(
    //                 <>
    //                 <button className="btn btn-primary" onClick={()=>{requestApproveUpdateRating(params.value, params.data.record_id)}}>Approve</button>
    //                 <button className="btn btn-primary ms-1" onClick={()=>{window.open(`/view-ratings-jcr-changes/${params.data.record_id}`, "_blank")}}>View</button>
    //                 </>
    //             )
    //         }
    //      else if (params.data.request == "Delete"){
    //             return(
    //                 <button className="btn btn-primary" onClick={()=>{requestApproveDeleteRating(params.value, params.data.record_id)}}>Approve</button>
    //             )
    //         }
    //   },
    // },

    // ];
  
  const MobViewRender = (params) => (
    <h1 style={{ padding: "10px 20px" }}>
      {/* <Table className="overflow-scroll responsiveTableFonts">
        {props.screenWidth <= 500 ? (
          <TableRow>
            <TableCell
              variant="head"
              className="fw-bolder responsiveTableFonts py-1"
            >
              Sector
            </TableCell>
            <TableCell className="responsiveTableFonts py-1">
              {params.data.Industry}
            </TableCell>
          </TableRow>
        ) : null}
        <TableRow>
          <TableCell
            variant="head"
            className="fw-bolder responsiveTableFonts py-1"
          >
            Rating Type
          </TableCell>
          <TableCell className="responsiveTableFonts py-1">
            {params.data.RatingScale}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            variant="head"
            className="fw-bolder responsiveTableFonts py-1"
          >
            Action
          </TableCell>
          <TableCell className="responsiveTableFonts py-1">
            {params.data.RatingAction}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            variant="head"
            className="fw-bolder responsiveTableFonts py-1"
          >
            R|LT
          </TableCell>
          <TableCell className="responsiveTableFonts py-1">
            {params.data.RatingLT}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            variant="head"
            className="fw-bolder responsiveTableFonts py-1"
          >
            R|ST
          </TableCell>
          <TableCell className="responsiveTableFonts py-1">
            {params.data.RatingST}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            variant="head"
            className="fw-bolder responsiveTableFonts py-1"
          >
            Outlook
          </TableCell>
          <TableCell className="responsiveTableFonts py-1">
            {params.data.Outlook}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            variant="head"
            className="fw-bolder responsiveTableFonts py-1"
          >
            PR
          </TableCell>
          <TableCell className="responsiveTableFonts py-1">
            {params.value === "nullData" ? (
              <Skeleton />
            ) : (params.data.pr !== null && params.data.pr !== '') ? (
              <a
                href={`${url}/view/public/${params.data.pr}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                <Check style={{ size: "20 20" }} className="theme_text" />{" "}
              </a>
            ) : (
              <Clear className="theme_text" />
            )}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            variant="head"
            className="fw-bolder responsiveTableFonts py-1"
          >
            RR
          </TableCell>
          <TableCell className="responsiveTableFonts py-1">
            {params.value === "nullData" ? (
              <Skeleton />
            ) : (params.data.sr !== null && params.data.sr !== '')? (
              <a
                href={`${url}/view/public/${params.value}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                <Check className="theme_text" />{" "}
              </a>
            ) : (
              <Clear className="theme_text" />
            )}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell
            variant="head"
            className="fw-bolder responsiveTableFonts py-1"
          >
            H
          </TableCell>
          <TableCell className="responsiveTableFonts py-1">
            {params.value === "nullData" ? (
              <Skeleton />
            ) : params.data.Id ? (
              <a
                href={`/vis-history/${params.data.Id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Event className="theme_text" />
              </a>
            ) : (
              <Clear className="theme_text" />
            )}
          </TableCell>
        </TableRow>
      </Table> */}
    </h1>
  );

  return (
    <div>
      <p className="mx-auto p-3 fs-3 fw-bold mb-0 text-capitalize" style={{ width: "fit-content", color:"#000078" }}>
        VIS Approval Requests
      </p> 
        <Box className="mx-auto" sx={{ width: "98%" }}>
            <Collapse in={alertopen}>
                <Alert
                severity={alertType}
                action={
                    <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                        setalertOpen(false);
                    }}
                    >
                    <CloseIcon fontSize="inherit" />
                    </IconButton>
                }
                sx={{ mb: 2 }}
                >
                {AlertMessage}
                </Alert>
            </Collapse>
        </Box>
        <TableComponent
            value={"vis_opinion_approval"}
            // bd_grid = {true}
            state={props.state}
            Data={data}
            screenWidth={props.screenWidth}
            MobViewRender={MobViewRender}
            columnDefs={columnDefs}
            datefilter={false}
            count={props.count}
        />

        {/* <p className="mx-auto p-3 fs-3 fw-bold mb-0 text-capitalize" style={{ width: "fit-content", color:"#000078" }}>
            Approvals For Rating
        </p> 

        <Box className="mx-auto" sx={{ width: "98%" }}>
            <Collapse in={alertopen2}>
                <Alert
                severity={alertType2}
                action={
                    <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => {
                        setalertOpen(false);
                    }}
                    >
                    <CloseIcon fontSize="inherit" />
                    </IconButton>
                }
                sx={{ mb: 2 }}
                >
                {AlertMessage2}
                </Alert>
            </Collapse>
        </Box>
        <TableComponent
            value={"vis_rating_approval"}
            bd_grid = {true}
            state={props.state}
            Data={rating}
            screenWidth={props.screenWidth}
            MobViewRender={MobViewRender}
            columnDefs={columnDefs2}
            datefilter={false}
            count={props.count}
        /> */}
    </div>
  )


}
